export const chainJSON = (block, text, obj) => {
  let index = -1;
  let splitIndex = -1;
  let empty = {}

  // 有可能會抓不到
  if(!block) return text;

  // 有可能會抓不到
  splitIndex = block.search(/(-|\.)/);

  if(splitIndex < 0) {
    return {
      ...obj,
      [block]: text
    }
  }

  // 取key, 並把key扣掉
  let key = block.slice(0, splitIndex);
  const spliter = block.substr(splitIndex, 1);
  block = block.slice(splitIndex + 1);

  // 抓得到
  if(spliter === "-") {
    // 是陣列
    // 取 index，並把 index 扣掉
    splitIndex = block.search(/(-|\.)/);
    splitIndex = splitIndex < 0 ? 100: splitIndex;
    index = +block.slice(0, splitIndex);
    block = block.slice(splitIndex + 1);
    empty = [];
  }

  if(!obj[key]) {
    obj[key] = empty;
  }

  if(spliter === "-") {
    obj[key][index] = chainJSON(block, text, obj[key][index]);
  } else {
    obj[key] = chainJSON(block, text, obj[key]);
  }
  return obj;
}



// WEBPACK FOOTER //
// ./src/utils/Lang.js